
export default {
  productDetail: {
    GroupPrice: '拼团价',
    GroupPeople: '人成团',
    Joined: '已拼',
    Items: '件',
    InitiatedGroup: '人已发起拼团，可直接点击去拼单',
    ViewAll: '查看全部',
    Remaining: '还差',
    OnlyLeft: '仅剩',
    GoToGroupOrder: '去拼单',
    GroupProcess: '拼团流程',
    ActivityRules: '活动规则',
    GroupLeader: '团长开团',
    InviteFriends: '邀请好友',
    GroupSuccess: '拼团成功',
    WaitingForShipment: '等待发货',
    DeliveredTo: '送至',
    SelectShippingAddress: '请选择收获地址',
    ShippingFee: '运费',
    ProductDetails: '商品详情',
    NoMoreContent: '没有更多内容了',
    Restocking: '正在补货',
    StartingFrom: '起',
    BuySeparately: '单独购买',
    InitiateGroupOrder: '发起拼单',
    JoinGroupBuying: '加入拼团',
    Remainings: '剩余',
    GroupBuyingInProgress: '正在拼团',
    GroupBuyingExplanation1: '1、用户参与拼团活动，开团成为团长，并邀请用户参团，在规定时间内参团人数达到限定人数，即组团成功，等待发货。',
    GroupBuyingExplanation2: '2、如在开团后规定时间内，参团人数未达到限定人数，或成团前库存售罄，则组团失败，系统自动取消订单，并全额原路退款至支付账户。',
    GroupBuyingExplanation3: '3、拼团购买仅支持在线支付，暂不支持货到付款。',
    GroupBuyingExplanation4: '4、关于取消订单的说明: 如拼团订单未成功支付，若其参与的团已拼成功或失败，则该拼团订单自动取消; 拼团订单支付成功后不支持取消订单; 拼团失败时该团所有订单自动取消。',
    GroupBuyingExplanation5: '5、对于部分超值热销的商品，会设定拼团限购数量，敬请留意提示，如存在违规行为、通过不正当手段参与优惠活动，FAFULI有权取消您的参与资格，相关优惠作废。',
    GroupBuyingExplanation6: '6、在FAFULI个人中心——我的拼团，可以查看自己的拼团。',
    GroupBuyingExplanation7: '7、FAFULI可在法律允许范围内对本活动规则进行解释。',
    Quantity: '数量',
    LimitQuantity: '限购数量',
    Confirm: '确定',
    Cancel: '取消',
    GroupBuyingEnded: '拼团已结束！',
    ExceededLimitQuantity: '超出限购数量！',
    SelectSpecification: '请选择规格！',
    ProductOutOfStock: '该商品已下架！',
    ActivityEnded: '活动已结束！',
    Liked: '赞！',
    GroupedAt: '元拼了',
    FriendRecommendation: '好友向你推荐这个拼团，超划算！'
  }
}
